export default function Admission() {
  return (
    <section id="kemasukan" className="py-20 bg-gradient-to-b from-emerald-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-4">Kemasukan Pelajar</h2>
          <div className="w-24 h-1 bg-yellow-500 mx-auto mb-6"></div>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Sertai kami dalam melahirkan generasi huffaz yang cemerlang
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/35100f66a40fdf5c6a0736f4b88283f6.jpg"
              alt="Pelajar Madrasah"
              className="rounded-2xl shadow-2xl w-full h-auto object-cover object-top"
            />
          </div>
          
          <div>
            <h3 className="text-3xl font-bold text-emerald-900 mb-6">Syarat Kemasukan</h3>
            
            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-md">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-1">Umur</h4>
                  <p className="text-gray-700">7 hingga 13 tahun (Tahun 1 hingga Tingkatan 1)</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-md">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-1">Bacaan Al-Quran</h4>
                  <p className="text-gray-700">Boleh membaca Al-Quran dengan betul (akan diuji)</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-md">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-1">Kesihatan</h4>
                  <p className="text-gray-700">Sihat tubuh badan dan tiada penyakit kronik</p>
                </div>
              </div>
              
              <div className="flex items-start gap-4 p-4 bg-white rounded-xl shadow-md">
                <div className="w-10 h-10 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-check-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h4 className="font-bold text-emerald-900 mb-1">Komitmen</h4>
                  <p className="text-gray-700">Komitmen ibu bapa dan pelajar untuk menamatkan hafazan</p>
                </div>
              </div>
            </div>
            
            <button className="bg-yellow-500 text-emerald-900 px-8 py-4 rounded-full font-semibold text-lg hover:bg-yellow-400 transition-all shadow-lg w-full md:w-auto cursor-pointer whitespace-nowrap">
              Muat Turun Borang Permohonan
            </button>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12 mb-12">
          <h3 className="text-3xl font-bold text-emerald-900 mb-8 text-center">Tatacara Permohonan</h3>
          
          <div className="grid md:grid-cols-4 gap-6">
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-full mx-auto mb-4 text-white text-2xl font-bold">
                1
              </div>
              <h4 className="font-bold text-emerald-900 mb-2">Isi Borang</h4>
              <p className="text-gray-600 text-sm">Lengkapkan borang permohonan secara online atau manual</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-full mx-auto mb-4 text-white text-2xl font-bold">
                2
              </div>
              <h4 className="font-bold text-emerald-900 mb-2">Hantar Dokumen</h4>
              <p className="text-gray-600 text-sm">Sertakan salinan sijil lahir, kad pengenalan dan gambar</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-full mx-auto mb-4 text-white text-2xl font-bold">
                3
              </div>
              <h4 className="font-bold text-emerald-900 mb-2">Ujian Saringan</h4>
              <p className="text-gray-600 text-sm">Hadiri ujian bacaan Al-Quran dan temuduga</p>
            </div>
            
            <div className="text-center">
              <div className="w-20 h-20 flex items-center justify-center bg-gradient-to-br from-emerald-600 to-emerald-800 rounded-full mx-auto mb-4 text-white text-2xl font-bold">
                4
              </div>
              <h4 className="font-bold text-emerald-900 mb-2">Keputusan</h4>
              <p className="text-gray-600 text-sm">Terima keputusan dan daftar sebagai pelajar</p>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-emerald-700 to-emerald-900 rounded-2xl p-8 text-white">
            <h3 className="text-2xl font-bold mb-6">Yuran Madrasah</h3>
            
            <div className="space-y-4">
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span>Yuran Pendaftaran (Sekali)</span>
                <span className="font-bold">RM 600</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span>Yuran Bulanan</span>
                <span className="font-bold">RM 300</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20">
                <span>Yuran Tahunan</span>
                <span className="font-bold">RM 200</span>
              </div>
              <div className="flex justify-between items-center pb-3 border-b border-white/20 mt-4 pt-4">
                <span className="font-bold text-lg">Jumlah Keseluruhan</span>
                <span className="font-bold text-lg">RM 1,100</span>
              </div>
            </div>
            
            <div className="mt-6 p-4 bg-white/10 backdrop-blur-sm rounded-lg">
              <p className="text-sm text-emerald-100">
                <strong>Nota:</strong> Yuran bayaran pendaftaran adalah termasuk dengan bayaran baju outing dan kopiah tahfiz. Biasiswa tersedia untuk pelajar yang layak.
              </p>
            </div>
          </div>
          
          <div className="bg-gradient-to-br from-yellow-500 to-yellow-600 rounded-2xl p-8 text-emerald-900">
            <h3 className="text-2xl font-bold mb-6">Biasiswa & Tajaan</h3>
            
            <div className="space-y-4">
              <div className="bg-white/30 backdrop-blur-sm p-4 rounded-lg">
                <h4 className="font-bold mb-2 flex items-center gap-2">
                  <i className="ri-medal-line text-xl"></i>
                  Biasiswa Kecemerlangan
                </h4>
                <p className="text-sm">Untuk pelajar cemerlang akademik - Potongan 50% yuran</p>
              </div>
              
              <div className="bg-white/30 backdrop-blur-sm p-4 rounded-lg">
                <h4 className="font-bold mb-2 flex items-center gap-2">
                  <i className="ri-hand-heart-line text-xl"></i>
                  Biasiswa Asnaf
                </h4>
                <p className="text-sm">Untuk keluarga asnaf - Potongan 70% yuran</p>
              </div>
              
              <div className="bg-white/30 backdrop-blur-sm p-4 rounded-lg">
                <h4 className="font-bold mb-2 flex items-center gap-2">
                  <i className="ri-group-line text-xl"></i>
                  Tajaan Dermawan
                </h4>
                <p className="text-sm">Tajaan penuh dari dermawan - 100% percuma</p>
              </div>
            </div>
            
            <button className="mt-6 bg-emerald-900 text-white px-6 py-3 rounded-full font-semibold hover:bg-emerald-800 transition-colors w-full cursor-pointer whitespace-nowrap">
              Mohon Biasiswa
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
